import { Shield, Phone, Mail, MapPin, Clock } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Footer = () => {
  const { t } = useTranslation();
  
  return (
    <footer className="bg-foreground text-background">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Marke & Kontakt */}
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <Shield className="h-8 w-8 text-accent" />
              <span className="text-xl font-bold">{t('footer.brand')}</span>
            </div>
            <p className="text-background/80">
              {t('footer.tagline')}
            </p>
            
            <div className="space-y-2">
              <div className="flex items-center gap-2">
                <Phone className="h-4 w-4 text-accent" />
                <span className="font-semibold">{t('footer.contact.support')}</span>
              </div>
              <div className="flex items-center gap-2">
                <Mail className="h-4 w-4 text-accent" />
                <span>{t('footer.contact.email')}</span>
              </div>
              <div className="flex items-center gap-2">
                <Clock className="h-4 w-4 text-accent" />
                <span>{t('footer.contact.availability')}</span>
              </div>
            </div>
          </div>

          <div>
            <h4 className="font-semibold mb-4">{t('footer.services.title')}</h4>
            <ul className="space-y-2 text-background/80">
              <li>
                <Link to="/services/betrugs-erkennung" className="hover:text-accent transition-colors">
                  AI-Betrugs-Erkennung
                </Link>
              </li>
              <li>
                <Link to="/services/hotline" className="hover:text-accent transition-colors">
                  Telefon-Support
                </Link>
              </li>
              <li>
                <Link to="/services/smartphone-setup" className="hover:text-accent transition-colors">
                  Smartphone-Setup
                </Link>
              </li>
              <li>
                <Link to="/services/alltagsunterstuetzung" className="hover:text-accent transition-colors">
                  Alltagsunterstützung
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">{t('footer.legal.title')}</h4>
            <ul className="space-y-2 text-background/80">
              <li><Link to="/impressum" className="hover:text-accent transition-colors">{t('footer.legal.impressum')}</Link></li>
              <li><Link to="/datenschutz" className="hover:text-accent transition-colors">{t('footer.legal.datenschutz')}</Link></li>
              <li><Link to="/agb" className="hover:text-accent transition-colors">{t('footer.legal.agb')}</Link></li>
              <li><Link to="/widerrufsrecht" className="hover:text-accent transition-colors">{t('footer.legal.widerrufsrecht')}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">{t('footer.emergency.title')}</h4>
            <div className="space-y-4">
              <div className="space-y-2">
                <div className="flex items-center gap-2">
                  <Phone className="h-4 w-4 text-accent" />
                  <span className="font-semibold">{t('footer.emergency.support')}</span>
                </div>
              </div>
              
              <div className="bg-background/10 p-4 rounded-lg">
                <div className="flex items-center gap-2 mb-2">
                  <MapPin className="h-4 w-4 text-accent" />
                  <span className="font-semibold">{t('footer.emergency.office')}</span>
                </div>
                <p className="text-sm text-background/80 whitespace-pre-line">
                  {t('footer.emergency.address')}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-background/20 mt-8 pt-8 text-center text-background/60">
          <p>{t('footer.copyright')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;